export default __webpack_public_path__ + "static/media/photo_and_video.2ff6cefd.jpg";